import React from 'react';
import PropTypes from 'prop-types';
import FieldText from '../fields/fieldText/FieldText';

import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {reduxForm, Field, SubmissionError, formValueSelector} from 'redux-form';
import Button from '../button/Button';

@injectIntl
class CheckoutCouponForm extends React.PureComponent {
  static propTypes = {
    coupon: PropTypes.string,
    applyCoupon: PropTypes.func,
    removeCoupon: PropTypes.func,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.coupon !== nextProps.coupon) {
      nextProps.change('promotionCoupon', nextProps.coupon || '');
    }
  }

  submitForm = ({promotionCoupon}) => {
    const {applyCoupon, removeCoupon} = this.props;

    return (this.props.coupon ? removeCoupon() : applyCoupon(promotionCoupon)).catch((err) => {
      if (!err instanceof SubmissionError) {
        throw err;
      }

      if (!err.errors.promotionCoupon) {
        err.errors.promotionCoupon = err.errors._error;
      }

      throw err;
    });
  };

  render() {
    const {intl, coupon, promotionCoupon, walletFundsApplied, handleSubmit, submitting} = this.props;

    return (
      <form className="checkout__coupon" onSubmit={handleSubmit(this.submitForm)}>
        <Field
          name="promotionCoupon"
          type="text"
          placeholder={intl.formatMessage({ id: 'section.coupon.code' })}
          disabled={walletFundsApplied || !!coupon}
          component={FieldText}
          className={coupon ? 'field-text--success' : ''}
        />

        <Button filled={!coupon} fill={!!coupon} loading={submitting} disabled={walletFundsApplied || submitting || (!promotionCoupon && !coupon)}>
          {coupon
            ? intl.formatMessage({ id: 'section.coupon.remove' })
            : intl.formatMessage({ id: 'section.coupon.apply' })}
        </Button>
      </form>
    );
  }
}

CheckoutCouponForm = reduxForm({
  form: 'checkoutCoupon'
})(CheckoutCouponForm);

const selector = formValueSelector('checkoutCoupon');
CheckoutCouponForm = connect((state) => {
  return {
    promotionCoupon: selector(state, 'promotionCoupon')
  };
})(CheckoutCouponForm);

export default CheckoutCouponForm;



// WEBPACK FOOTER //
// ./components/checkout/CheckoutCouponForm.js